import React, { useEffect } from 'react'
import { SnackbarAlert } from '@labrav/react-components'
import { useDispatch, useSelector } from 'react-redux'

import { updateAppAlert } from '../../modules/appAlert/actions'
import type { AppAlertState } from '../../modules/appAlert/reducer'
import { CRMAuthSuccessMessage } from '../../utils/messagesContants'

type SnackBarRootState = {
  appAlert: AppAlertState
}

export const SnackBar = () => {
  const errorState = useSelector((state: SnackBarRootState) => state.appAlert)
  const dispatch = useDispatch()

  const close = () => {
    const resetError: AppAlertState = {
      message: undefined,
      messageType: 'NONE',
    }
    dispatch(updateAppAlert(resetError))
  }

  useEffect(() => {
    if (errorState?.autoClose && errorState.message !== CRMAuthSuccessMessage) {
      const timer = setTimeout(close, 10000)
      return () => clearTimeout(timer)
    }
  }, [errorState])

  if (!errorState?.message) {
    return null
  }

  return (
    <SnackbarAlert
      snackbarAlertType={
        errorState.messageType === 'SUCCESS' ? 'success' : 'failure'
      }
      open={true}
      handleClose={close}
      message={errorState.message}
    />
  )
}
